import { I18NextPipe } from 'angular-i18next';
import { OsType, OSTypeAdapter } from 'mbs-ui-shared@models/Computer';

export type OSTypeModel = {
  id: OsType;
  name: string;
  multipleSelect?: boolean;
};

export const getOSTypes = (i18N: I18NextPipe) =>
  OSTypeAdapter.map((value) => ({ id: value.os, name: i18N.transform(`shared:computers.searchOSType:${value.displayOS}`) }) as OSTypeModel);
